import React, { useEffect } from "react";
import { Images } from "../../theme";
import { Link } from "react-router-dom";
import "./styles.css";
import { useState } from "react";
import { Modal } from "react-responsive-modal";
import Login from "../../containers/Auth/Login";
import SignUp from "../../containers/Auth/SignUp";
import ForgotPassword from "../../containers/Auth/ForgotPassword";
import ResetPassword from "../../containers/Auth/ResetPassword";
import { useTranslation } from "react-i18next";
import { TranslatorDropdown } from "../";

export default (props) => {
  let loginIsActive = props.loginIsActive ? props.loginIsActive : false;
  const { t } = useTranslation();
  const [email, setEmail] = useState("");

  const [activeCanva, SetactiveCanva] = useState(false);

  const [loginModal, setLoginModal] = useState(false);
  const [signupModal, setSignupModal] = useState(false);
  const [forgotModal, setForgotModal] = useState(false);
  const [resetModal, setResetModal] = useState(false);

  useEffect(() => {
    setLoginModal(loginIsActive);
  }, [loginIsActive]);

  const onCloseForgotModal = () => setForgotModal(false);
  const onCloseForgotSeccessModal = () => {
    setForgotModal(false);
    setResetModal(true);
  };
  const onCloseModal = () => {
    setLoginModal(false);
    props.setIsActiveLogin(false);
  };
  const onCloseResetModal = () => setResetModal(false);
  const onCloseSignupModal = () => setSignupModal(false);

  const loginClick = () => {
    setLoginModal(true);
    SetactiveCanva(true);
  };

  const signUpClick = () => {
    setSignupModal(true);
    SetactiveCanva(true);
  };

  const toggleClick = () => {
    SetactiveCanva(false);
  };

  return (
    <nav class="container navbar navbar-expand-lg navbar-light py-4">
      <div class="container-fluid">
        <a class="navbar-brand">
          <Link to="/">
            <img className="logo-icon" src={Images.logo_blue} alt="image" />
          </Link>
        </a>
        {/* <Link
          to="/login"
          href="#"
          className="d-none Opensans color-black text-decoration-none signin-mobile"
        >
          {" "}
          Sign in
        </Link> */}
        <button
          onClick={toggleClick}
          class="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          href="#offcanvasExample"
          role="button"
          aria-controls="offcanvasExample"
        >
          <img src={Images.menu} />
        </button>
        <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
          <ul class="navbar-nav me-auto mb-lg-0">
            <li class="nav-item nav-home d-flex" style={{ marginLeft: 40 }}>
              <Link to="/Renting">
                <a class="nav-link nav-text headerLanding">{t("Rent")}</a>
              </Link>
              <Link to="/Lending">
                <a class="nav-link nav-text headerLanding">{t("Lend")}</a>
              </Link>
            </li>
          </ul>
          <form class="d-flex form-auth">
            <Link onClick={() => setLoginModal(true)} to="">
              <button
                class={
                  props.white
                    ? "header-button-login-white pointer"
                    : "header-button-login pointer"
                }
              >
                {t("Sign_In")}
              </button>
            </Link>
            <Link onClick={() => setSignupModal(true)} to="">
              <button
                class={
                  props.white
                    ? "header-button-login-white pointer"
                    : "header-button-login pointer"
                }
              >
                {t("Sign_Up")}
              </button>
            </Link>
            <TranslatorDropdown white={props.white} />
          </form>
        </div>
        {!activeCanva ? (
          <div
            class="offcanvas offcanvas-start"
            tabindex="-1"
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
          >
            <div class="offcanvas-header">
              <a class="navbar-brand m-auto" href="#">
                <img className="logo-icon" src={Images.logo_blue} alt="image" />
              </a>
              <button
                type="button"
                class="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div class="offcanvas-body">
              <ul class="navbar-nav me-auto mb-lg-0">
                <li class="nav-item nav-home d-flex" style={{ marginLeft: 40 }}>
                  <Link to="/Renting">
                    <a class="nav-link nav-text headerLanding">{t("Rent")}</a>
                  </Link>
                  <Link to="/Lending">
                    <a class="nav-link nav-text headerLanding">{t("Lend")}</a>
                  </Link>
                  <Link onClick={loginClick} to="">
                    <a class="nav-link nav-text headerLanding extra-link">
                      {t("Sign_In")}
                    </a>
                  </Link>
                  <Link onClick={signUpClick} to="">
                    <a class="nav-link nav-text headerLanding extra-link">
                      {t("Sign_Up")}
                    </a>
                  </Link>
                  <TranslatorDropdown />
                </li>
              </ul>
            </div>
          </div>
        ) : null}
      </div>
      <Modal open={loginModal} onClose={onCloseModal} center>
        <Login
          setLoginModal={setLoginModal}
          onPressForgot={() => {
            setForgotModal(true);
            onCloseModal();
          }}
          onPressSignIn={() => {
            setSignupModal(true);
            onCloseModal();
          }}
        />
      </Modal>
      <Modal open={resetModal} onClose={onCloseResetModal} center>
        <ResetPassword
          {...props}
          onCloseResetModal={onCloseResetModal}
          email={email}
        />
      </Modal>
      <Modal open={signupModal} onClose={onCloseSignupModal} center>
        <SignUp
          setSignupModal={setSignupModal}
          onPressForgot={() => {
            setLoginModal(true);
            onCloseSignupModal();
          }}
        />
      </Modal>
      <Modal open={forgotModal} onClose={onCloseForgotModal} center>
        <ForgotPassword
          {...props}
          onCloseForgotModal={onCloseForgotSeccessModal}
          emailState={setEmail}
        />
      </Modal>
    </nav>
  );
};
